import { ownershipTypesConfig } from "../../../components/modules/kyc/shared/config";
import { FormatDateMapper } from "../FormatDateMapper";
import { parseStringAmountWithUnitToNumber } from "../../formaters";
import { DataTransform } from "@nemuru-eng/js-api-client";
import { addressMapper } from "../../../components/modules/kyc/shared/AutocompleteAddressHeadless/components/GoogleMapsAutocomplete/mappers/addressMapper";

export const MainResidenceDetailsMapper = {
  reverseMap(data) {
    return {
      address: DataTransform.camelToSnake(addressMapper.toDto(data.address)),
      ownership_type: data.ownershipType,
      ...(data.ownershipType === ownershipTypesConfig.OWNERSHIP.value
        ? { property_type: data.propertyType }
        : {}),
      entrance_date: FormatDateMapper.dehydrate(data.entranceDate),
      mortgage: !!data.mortgage,
      home_expenses: {
        amount: data.homeExpensesAmount
          ? parseInt(
              parseStringAmountWithUnitToNumber(data.homeExpensesAmount),
              10
            )
          : 0,
        currency: "EUR",
      },
    };
  },
};
